import React from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';

const FooterContainer = styled.footer`
  padding: 20px;
  display: flex;
  gap: 30px;
  justify-content: center;
  align-items: center;
  width: 100%;
  
  @media (max-width: 480px) {
    flex-direction: column;
    gap: 15px;
  }
`;

const FooterLink = styled(Link)`
  color: ${props => props.$primary ? '#FFD700' : '#FFFFFF'};
  text-decoration: none;
  font-size: 18px;
  font-weight: bold;
  text-transform: uppercase;
  letter-spacing: 1px;
  padding: 8px 12px;
  transition: transform 0.2s, opacity 0.2s;
  
  &:hover {
    transform: translateY(-2px);
    opacity: 0.8;
  }
  
  &:active {
    transform: translateY(0);
  }
  
  @media (max-width: 480px) {
    font-size: 16px;
  }
`;

const ContactLink = styled.a`
  color: #FFFFFF;
  text-decoration: none;
  font-size: 18px;
  font-weight: bold;
  text-transform: uppercase;
  letter-spacing: 1px;
  padding: 8px 12px;
  transition: transform 0.2s, opacity 0.2s;
  
  &:hover {
    transform: translateY(-2px);
    opacity: 0.8;
  }
  
  &:active {
    transform: translateY(0);
  }
  
  @media (max-width: 480px) {
    font-size: 16px;
  }
`;

const Footer = () => {
  return (
    <FooterContainer>
      <FooterLink to="/terms">Terms of service</FooterLink>
      <FooterLink to="/privacy" $primary>Privacy policy</FooterLink>
      <ContactLink href="mailto:busybeehelp@littleapps.xyz">
        Contact us
      </ContactLink>
    </FooterContainer>
  );
};

export default Footer; 